import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../services/auth.service';
import { AuthfakeauthenticationService } from '../services/authfake.service';
import { AccessSessionStorage } from '../services/vs-services/session-storage.service';
import { LoginSessionInterface } from '../models/vs-interfaces/loginSessionInterface';


@Injectable({ providedIn: 'root' })
export class AuthGuard {
  loggedInSession: LoginSessionInterface;
    constructor(
        private router: Router,
        private userSession: AccessSessionStorage) { }
 
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.loggedInSession = JSON.parse(this.userSession.getLoginSessionData('userDetails'));
        if (this.loggedInSession?.success) {
            return true;
        }
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/account/auth/login'], { queryParams: { returnUrl: state.url } });
        return false;
        // return this.loggedInSession.success? true: false;
    }
}
